"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.TariffPlanStatus = exports.tariffType = exports.tariffComponentType = exports.priceUnit = exports.type = exports.unitOfMeasurement = exports.tariffPlanGroupType = exports.energyType = exports.segment = exports.brand = void 0;
exports.brand = {
    ENERGIEDIRECT: 'energiedirect',
    ESSENT: 'essent'
};
exports.segment = {
    HOUSEHOLD: 'household',
    SMALL_OFFICE_HOME_OFFICE: 'small_office_home_office',
    SMALL_MEDIUM_ENTERPRISE: 'small_medium_enterprise'
};
exports.energyType = {
    ELECTRICITY: 'electricity',
    GAS: 'gas'
};
exports.tariffPlanGroupType = {
    FIXED: 'fixed',
    FLEX: 'flex',
    DYNAMIC: 'dynamic'
};
/**
 * Unit of measurement.
 */
exports.unitOfMeasurement = {
    M_: 'm³',
    K_WH: 'kWh'
};
/**
 * Type of tariff.
 */
exports.type = {
    MARKET_PRICE: 'MARKET_PRICE',
    PURCHASING_FEE: 'PURCHASING_FEE',
    TAX: 'TAX'
};
exports.priceUnit = {
    EURO_PER_KWH: 'euro_per_kwh',
    EURO_PER_M3: 'euro_per_m3',
    EURO_PER_DAY: 'euro_per_day'
};
exports.tariffComponentType = {
    DELIVERY_COSTS_SINGLE: 'delivery_costs_single',
    DELIVERY_COSTS_PEAK: 'delivery_costs_peak',
    DELIVERY_COSTS_OFF_PEAK: 'delivery_costs_off_peak',
    FIXED_COSTS: 'fixed_costs',
    SURCHARGE_SINGLE_PRODUCT: 'surcharge_single_product',
    REDELIVERY_COSTS: 'redelivery_costs',
    REASONABLE_REDELIVERY_FEE: 'reasonable_redelivery_fee',
    REDELIVERY_FEE: 'redelivery_fee'
};
exports.tariffType = {
    FIXED: 'fixed',
    FLEX: 'flex',
    DYNAMIC: 'dynamic'
};
exports.TariffPlanStatus = {
    CONCEPT: 'concept',
    AWAITING_APPROVAL: 'awaiting-approval',
    APPROVED: 'approved',
    PUBLISHED: 'published',
    REVOKED: 'revoked',
    REJECTED: 'rejected'
};
